const advertisement = {
  getlist: 'advertisement/getlist-by-admin',
  get: 'advertisement/get-by-admin',
  update: 'advertisement/update-by-admin',
  moderate: 'advertisement/moderate',
}
export default advertisement
